import { useMemo } from 'react';
import { rgbaToHex } from '../../core/color';
import { sampleDocumentPixel } from '../../engine/histogram';
import { getEngine } from '../../engine/engine';
import { useHudStore } from '../../state/hud';
import { getActiveDocument, useAppStore } from '../../state/store';
import { Panel } from './Panel';

export function InfoPanel() {
  const doc = useAppStore(getActiveDocument);
  const pixelEpoch = useAppStore((state) => state.pixelEpoch);
  const fromComposite = useAppStore((state) => state.toolOptions.eyedropperFromComposite);
  const cursor = useHudStore((state) => state.cursor);

  const sample = useMemo(() => {
    void pixelEpoch;
    if (!doc || !cursor) return null;
    const engine = getEngine();
    if (!engine.available) return null;
    return sampleDocumentPixel(doc, cursor, fromComposite);
  }, [doc, cursor, fromComposite, pixelEpoch]);

  return (
    <Panel id="info" title="Info">
      <div className="panel__body info-panel">
        {!doc && <p className="dialog__note">Open a document to view document info.</p>}
        {doc && (
          <>
            <div className="info-panel__row">
              <span className="info-panel__label">Document</span>
              <span>
                {doc.width} × {doc.height} px
              </span>
            </div>
            <div className="info-panel__row">
              <span className="info-panel__label">Cursor</span>
              <span>
                {cursor ? `${Math.round(cursor.x)}, ${Math.round(cursor.y)}` : '—'}
              </span>
            </div>
            <div className="info-panel__row">
              <span className="info-panel__label">Color</span>
              {sample ? (
                <span className="info-panel__color">
                  <span
                    className="info-panel__swatch"
                    style={{ background: rgbaToHex({ r: sample.r / 255, g: sample.g / 255, b: sample.b / 255, a: 1 }) }}
                  />
                  R {sample.r} G {sample.g} B {sample.b}{' '}
                  {rgbaToHex({ r: sample.r / 255, g: sample.g / 255, b: sample.b / 255, a: 1 }).toUpperCase()}
                </span>
              ) : (
                <span>—</span>
              )}
            </div>
          </>
        )}
      </div>
    </Panel>
  );
}
